import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { first, tap } from 'rxjs/operators';

@Component({
	selector: 'spaq-core-form',
	template: `
		<spaq-message-state
			*ngIf="error !== 'auth.multi-factor-auth-required'"
			[error]="error?.message || error"
			[success]="success?.message || success"
		></spaq-message-state>

		<form [formGroup]="formGroup">
			<ng-content></ng-content>
			<kendo-dialog-actions [hidden]="!dialog">
				<button
					*ngIf="!formGroup.disabled && cancel"
					[type]="'cancel'"
					[primary]="false"
					[hidden]="disabled"
					[disabled]="formGroup.disabled || !buttonEnable"
					[attr.data-testid]="cancelTestId"
					kendoButton
					class="btn btn-secondary ms-2"
					(click)="cancelForm.emit()"
				>
					<span>Annuler</span>
				</button>
				<button
					(click)="submit.focus(); onSubmit()"
					[hidden]="disabled"
					[id]="submitId"
					[attr.data-testid]="submitTestId"
					[primary]="true"
					[disabled]="formGroup.disabled || !buttonEnable"
					kendoButton
					name="submit"
					[ngClass]="{ 'w-100': !cancel }"
					type="submit"
					#submit
				>
					<i *ngIf="formGroup.disabled" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
					<span *ngIf="!formGroup.disabled">{{ submitValue }}</span>
				</button>
			</kendo-dialog-actions>
			<button
				*ngIf="showSubmit"
				(click)="submit.focus(); onSubmit()"
				[hidden]="disabled || dialog"
				[id]="submitId"
				[attr.data-testid]="submitTestId"
				[primary]="true"
				[disabled]="formGroup.disabled || !buttonEnable"
				kendoButton
				name="submit"
				[ngClass]="{ 'w-100': !cancel }"
				class="mt-4"
				type="submit"
				#submit
			>
				<i *ngIf="formGroup.disabled" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
				<span *ngIf="!formGroup.disabled">{{ submitValue }}</span>
			</button>
			<button
				*ngIf="!formGroup.disabled && cancel"
				[type]="'cancel'"
				[primary]="false"
				[hidden]="disabled || dialog"
				[disabled]="formGroup.disabled || !buttonEnable"
				[attr.data-testid]="cancelTestId"
				kendoButton
				class="btn btn-secondary mt-4 ms-2"
				(click)="cancelForm.emit()"
			>
				<span>Annuler</span>
			</button>
		</form>
	`,
	styles: [
		`
			.loading {
				position: absolute;
				top: 0;
				right: 0;
				left: 0;
				bottom: 0;
				z-index: 1000;
			}

			form {
				position: relative;
			}
		`
	]
})
export class CoreFormComponent implements OnInit {
	_values = {};
	@Input() disabled = false;
	@Input() cancel = false;
	@Input() dialog = false;
	@Input() showSubmit = true;
	@Input() buttonEnable = true;
	@Input() error;
	@Input() formGroup: FormGroup;
	@Input() name = 'form';
	@Input() onError = new EventEmitter();
	@Input() onSuccess = new EventEmitter();
	@Input() onUpdate = new EventEmitter();
	@Output() formSubmit = new EventEmitter();
	@Output() cancelForm = new EventEmitter();
	@Input() submitValue = 'Continuer';
	subscriptionForm: Subscription;
	@Input() success;
	private _pending = false;
	// private _disabledControlPaths: string[] = [];

	@Input()
	set pending(state) {
		const pending = state === true;
		if (!this.formGroup || pending === this._pending) {
			return;
		}
		this._pending = pending;
		if (pending) {
			this.formGroup.disable({ emitEvent: false });
		} else {
			this.formGroup.enable({ emitEvent: false });
		}
	}

	get submitId() {
		return `${this.name.toLowerCase()}_submit`;
	}

	get submitTestId() {
		return this.submitId;
	}

	get cancelTestId() {
		return `${this.name.toLowerCase()}_cancel`;
	}

	@Input()
	set values(data: any) {
		if (this.formGroup) {
			if (data) {
				this.formGroup.patchValue(data, { emitEvent: false });
			}
		} else {
			this._values = data;
		}
	}

	constructor() {}
	ngOnInit() {
		if (this._values && this.formGroup) {
			this.formGroup.patchValue(this._values);
		}
	}

	private markFormGroupTouched(formGroup: FormGroup) {
		(Object as any)
			.keys(formGroup.controls)
			.map(c => formGroup.controls[c])
			.forEach(control => {
				if (control.controls) {
					this.markFormGroupTouched(control);
				} else {
					control.markAsTouched();
					control.updateValueAndValidity();
				}
			});
	}

	emitError() {
		if (this.onError) {
			this.onError.emit(this.formGroup.getRawValue());
		}
	}

	emitSuccess() {
		if (this.onSuccess) {
			this.onSuccess.emit(this.formGroup.getRawValue());
		}
		this.emitUpdate();
	}

	emitUpdate() {
		if (this.onUpdate) {
			this.onUpdate.emit(this.formGroup.getRawValue());
		}
	}

	onSubmit() {
		this.markFormGroupTouched(this.formGroup);
		this.emitUpdate();
		if (this.formGroup.valid) {
			return this.emitSuccess();
		}
		this.formGroup.statusChanges
			.pipe(
				tap(() => {
					this.formGroup.valid ? this.emitSuccess() : this.emitError();
				}),
				first()
			)
			.subscribe();
	}
}
